// The tensor app (design 02, 1st stage): https://tensor.housemouse.dev, its
// own PWA next to talk. Built by vite.tensor.config.ts (root tensor/, out
// dist-tensor/); the screens and helpers are here in src/tensor/.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '../styles.css'
import './tensor.css'
import { applyFontSize, fontSize } from '../lib/fontSize'
import { leaveKakaoTalk } from '../lib/inapp'
import { applyTheme, theme } from '../lib/theme'
import { KakaoGate } from '../ui/InApp'
import { engine } from './engine'
import { App } from './ui/App'

// KakaoTalk's own browser can neither install the app nor notify: off to
// the phone's browser first (lib/inapp.ts).
const inKakaoTalk = leaveKakaoTalk()
applyFontSize(fontSize())
applyTheme(theme())
engine.start()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <KakaoGate show={inKakaoTalk}>
      <App />
    </KakaoGate>
  </StrictMode>,
)

// The service worker makes the app installable and keeps its files for a
// start without a connection (tensor/public/sw.js). It needs a secure
// context: HTTPS, or localhost during development.
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined)
  })
}
